import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class WindowProvider {
    public getWindow() {
        return window;
    }
}
